import { createContext } from 'react';

const ConfirmContext = createContext(null);
ConfirmContext.displayName = 'ConfirmContext';

export default ConfirmContext;
